module.exports = function() {
	return new Worker(__webpack_public_path__ + "ee72ec452deaaea2777a.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./src/logic/adsAnalyzer.js
// module id = 481
// module chunks = 0